import { mapState, mapActions } from 'vuex'
import cardDraft from '@/components/cards/card-draft/card-draft.vue'
import infiniteScroll from 'vue-infinite-scroll'
import spinner from '@/components/common/spinner/spinner.vue'

export default {
  directives: { infiniteScroll },
  data() {
    return {
      competitionsList: [],
      busy: false,
      page: 1,
      total: 0,
      isLoading: false
    }
  },
  computed: {
    ...mapState('user', ['currentUser']),
    ...mapState('competition', ['competitions', 'searchedText']),
    userJSON() {
      return JSON.stringify(this.currentUser, null, 2)
    }
  },
  components: {
    cardDraft,
    spinner
  },
  watch: {
    searchedText: function () {
      this.search()
    }
  },
  methods: {
    ...mapActions('competition', ['getCompetitions']),
    loadMore: async function () {
      if (this.competitionsList.length < this.total) {
        this.busy = true

        const moreData = await this.getCompetitions({
          page: ++this.page,
          status: 'draft',
          search: this.searchedText
        })

        this.competitionsList = this.competitionsList.concat(moreData.docs)
        this.busy = false
      }
    },
    search: async function () {
      this.isLoading = true
      try {
        const competitionsRes = await this.getCompetitions({
          page: 1,
          status: 'draft',
          search: this.searchedText
        })
        this.competitionsList = competitionsRes.docs
        this.total = competitionsRes.total
      } catch (e) {
        throw e.response
      }
      this.isLoading = false
    }
  },
  created() {
    this.search()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/dashboard-draft/dashboard-draft.js